import { checkForFandomCmpAllowed } from "./index";

export const createCmpRestrictedObject = <T extends Record<string, any>>(
  fandomContext: T,
): Partial<T> => {
  const handler: ProxyHandler<T> = {
    get(target, prop: keyof FandomContext) {
      if (!checkForFandomCmpAllowed("tracking")) {
        return undefined;
      }

      return target[prop];
    },
  };

  return new Proxy(fandomContext, handler);
};
